import { NgModule } from "@angular/core";
import { ImportComponent } from "./import.component";
import { SpreadsheetModule } from "../s25-spreadsheet/s25.spreadsheet.module";
import { FormsModule } from "@angular/forms";
import { S25DropdownPaginatedModule } from "../s25-dropdown/s25.dropdown.paginated.module";
import { S25ImportEventsComponent } from "./import.events.component";
import { S25ImportOrganizationsComponent } from "./import.organizations.component";
import { S25ImportContactsComponent } from "./import.contacts.component";
import { S25ImportMasterDefinitionsComponent } from "./import.master.definitions.component";
import { S25ImportBudgetsComponent } from "./import.budgets.component";
import { ImportCustomAttributeTypesComponent } from "./import.custom.attribute.types.component";

@NgModule({
    declarations: [ImportComponent],
    imports: [
        SpreadsheetModule,
        FormsModule,
        S25DropdownPaginatedModule,
        S25ImportEventsComponent,
        S25ImportOrganizationsComponent,
        S25ImportContactsComponent,
        S25ImportMasterDefinitionsComponent,
        S25ImportBudgetsComponent,
        ImportCustomAttributeTypesComponent,
    ],
    exports: [ImportComponent],
    providers: [ImportComponent],
})
export class ImportModule {}
